
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class Automaticrentrenewal {

  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  GetCombinedMonthlyReservationforARR(startyearmonth: string, noofmonths: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetCombinedMonthlyReservationforARR?startyearmonth=${startyearmonth}&noofmonths=${noofmonths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

  combinePdfs(base64Pdfs: string[]): Observable<{ Success: boolean, CombinedPdf: string }> {
    return this.http.post<{ Success: boolean, CombinedPdf: string }>(this.baseURL + '/PaymentReceipt/combine', base64Pdfs);
  }

  displayARRReceipts(accountreceiptids: number[], rentaltype: number, email: boolean): Observable<any> {
    const safeRentalType = rentaltype ?? 0;
    const safeEmail = email === true; // ensures true / false
    const url = `${this.baseURL}/PaymentReceipt/DisplayARRReceipts` + `?Rentaltype=${safeRentalType}&email=${safeEmail}`;

    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<any>(url, accountreceiptids, options).pipe(
      map(res => res as any),
      catchError(this.handleError)
    );
  }

  saveCombinedMonthlyRentalsARR(
    startyearmonth: string,
    numofmonths: number,
    Renewothercharges: boolean,
    ExcludeflagARR: boolean,
    notes: string | null,
    chunkReservations: any[],
    otheritemchargesALL: any[],
    paid: boolean,
    dateOfRenewal: string
  ): Observable<any> {
    const flattenedReservations = [].concat(...chunkReservations);
    const requestBody = {
      StartYearMonth: startyearmonth,
      NumOfMonths: numofmonths,
      RenewOtherCharges: Renewothercharges,
      ExcludeFlagARR: ExcludeflagARR,
      Notes: notes,
      Paid: paid,
      DateOfRenewal: dateOfRenewal,
      CombinedMonthlyRentalsARRRequest: {
        CMonthlyBookings: flattenedReservations,
        UpdatedOtherRentalCharges: otheritemchargesALL
      }
    };

    return this.http.post<any>(
      `${this.baseURL}/AutomaticRentRenewal/SaveCombinedMonthlyRentalsARR`,
      requestBody
    );
  }

  voidARRTransactions(voidTransactionRequest: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/AutomaticRentRenewal/VoidARRTransactions`,
      voidTransactionRequest,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}